export default () => {
  return <div>
    <div className="text-red-400 text-4xl">
      xxx
      </div>

  </div>
}